module.exports = __webpack_public_path__ + "img/yinyong.f2b46030.gif";